import React, { useState } from "react";
import "../styles/SignupPage.css";
import TextBox from "../components/TextBox";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/api";

export default function Login() {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: "", password: "" });

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    try {
      const response = await api.post("/auth/login/", {
        username: credentials.username, // backend expects username
        password: credentials.password,
      });

      localStorage.setItem("access", response.data.access);
      localStorage.setItem("refresh", response.data.refresh);
      localStorage.setItem("username", response.data.username);

      navigate("/dashboard");
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      alert("Login failed. Please check your credentials.");
    }
  };

  return (
    <div className="signup-page">
      <h1 className="signup-title">Welcome Back</h1>
      <p className="signup-subtitle">
        Sign in to continue your wellness journey
      </p>

      <div className="signup-card">
        {/* Card Header */}
        <div className="card-header">
          <h2 className="card-title">Sign In</h2>
          <p className="card-description">
            Enter your credentials to access your account
          </p>
        </div>

        {/* Card Content */}
        <div className="card-content">
          <div className="input-group">
            <label className="input-box-title">Username</label>
            <TextBox
              type="username"
              placeholder="you@example.com"
              name="username"
              value={credentials.username}
              onChange={handleChange}
            />
          </div>

          <div className="input-group">
            <label className="input-box-title">Password</label>
            <TextBox
              type="password"
              placeholder="Enter your password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
            />
          </div>

          <div
            className="terms-row"
            style={{ justifyContent: "space-between" }}
          >
            <div>
              <input type="checkbox" id="remember" />
              <label htmlFor="remember"> Remember me</label>
            </div>
            <a href="#">Forgot password?</a>
          </div>

          <button className="create-account-btn" onClick={handleLogin}>
            Sign In
          </button>

          <p className="login-prompt">
            Don’t have an account? <Link to="/signup">Signup here</Link>
          </p>
        </div>
      </div>

      <p className="signup-note">
        By signing in, you agree to our <a href="#">Terms of Service</a> and{" "}
        <a href="#">Privacy Policy</a>.
      </p>
    </div>
  );
}
